import {Component, Input} from '@angular/core';
import {BiowetterEffect, BiowetterVorhersage} from '../../../../../../../model/vorhersagen/biowetter';

@Component({
  selector: 'app-biowetter-vorhersage',
  templateUrl: './biowetter-vorhersage.component.html'
})
export class BiowetterVorhersageComponent {

  @Input()
  vorhersage: BiowetterVorhersage;

  hasSubEffects(effect: BiowetterEffect): boolean {
    return effect.subEffects.length !== 0;
  }

}
